import datefnsParse from "date-fns/parse";

export function parseFormDate(date) {
    if (typeof date !== 'undefined' && date !== null) {
        return datefnsParse(date, 'yyyy-MM-dd', new Date());
    } else {
        return new Date();
    }
}